import styled from "styled-components";
import { TiPage } from "@ti/ui-mobile";

export const Page = styled(TiPage)`
  .ti-page-header {
    padding-right: 0px;
  }
  .ti-page-header-right {
    display: flex;
    justify-content: flex-end;
  }
`;

export const SearchBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 12px 10px 12px;
  background-color: #fff;
  .ti_search {
    background-color: #f6f7fa;
    flex: 1;
  }
`;

export const ListContent = styled.div`
  background: #fff;
  margin-top: 10px;
  flex: 1;
  overflow-y: scroll;
`;
